import { Pipe, PipeTransform } from '@angular/core';
import { FeedingStage } from '../Enum/feedingstage.enum';


@Pipe({
  name: 'stageName'
})
export class StageNamePipe implements PipeTransform {
  transform(value: FeedingStage): string {
    switch (value) {
      case FeedingStage.PreStarter:
        return 'Pre Starter';
      case FeedingStage.Starter:
        return 'Starter';
      case FeedingStage.Grower:
        return 'Grower';
      case FeedingStage.Finisher:
        return 'Finisher';
      default:
        return '';
    }
  }
}